import React from "react";
import {BrandConfig} from "./BrandConfig";
import {applyBrandCssVariables, DEFAULT_BRAND, readBrandConfig} from "./readBrandConfig";

export const BrandContext = React.createContext<BrandConfig>(DEFAULT_BRAND);

/**
 * The query parameter that names the brand on every borrower request (HttpService), and on
 * payment links from before brands moved into the path, e.g. `?brand=triumph-lending`.
 */
export const BRAND_URL_PARAM = "brand";

/**
 * The brand this page renders with.
 *
 * Starts as the brand baked into the HTML, which is always the build-time default, and is
 * replaced by resolveBrand with the one the backend resolved, before React mounts. Nothing
 * changes it after render.
 */
let BRAND: BrandConfig = readBrandConfig();
let RESOLVED = false;
applyBrandCssVariables(BRAND);

export function currentBrand(): BrandConfig {
    return BRAND;
}

/**
 * The slug of the brand the backend resolved for this page, or null while the page is still on
 * its built-in fallback because the lookup failed. Requests name this brand so a payment is
 * attributed to what the borrower sees; the fallback is never named, because it may not be the
 * backend's default.
 */
export function resolvedBrandSlug(): string | null {
    return RESOLVED ? BRAND.slug : null;
}

/** Sets the brand resolveBrand fetched. Called before React mounts. */
export function setBrand(brand: BrandConfig): void {
    BRAND = brand;
    RESOLVED = true;
    applyBrandCssVariables(BRAND);
}

export class BrandProvider extends React.Component {
    render() {
        // Read at render rather than module load, so a pre-render override is picked up.
        return <BrandContext.Provider value={currentBrand()}>{this.props.children}</BrandContext.Provider>;
    }
}
